import React from "react";

import { SectionWrapper, Text } from "../../Styles/style";
import { BothButtons, HeaderContainer, ReadMore, VideoBG, } from "./styles";

import Video from "../../../assets/images/newvideo.mp4";
import mainImg from "../../../assets/images/mainImg.png"
import community from "../../../assets/images/community.png"
import buylink from "../../../assets/images/buylink.png"
import chart from "../../../assets/images/chart.png"
import styled from "@emotion/styled";
const MainImage = styled.img`
  width: 100%;
  max-width: 400px;
`
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "80%")};
`
const Section1_Header = () => {
  return (
    <SectionWrapper p="0rem 0">
      <HeaderContainer maxWidth="xl">
         <MainImage src={mainImg}/>
        <Text data-aos="zoom-in" data-aos-easing="ease-in" data-aos-delay="400" data-aos-duration="500" data-aos-offset="0" >
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea
        </Text>
        <BothButtons data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0" >
      
       <a href="/">
       <JOiningLinks src={buylink} />
       </a>
       <a href="/">
       <JOiningLinks src={community} />
       </a>
       <a href="/">
       <JOiningLinks src={chart} />
       </a>
        </BothButtons>
      </HeaderContainer>
    </SectionWrapper>
  );
};

export default Section1_Header;
